var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrainement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-school"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.07429 16.5169V20.1406C5.07429 21.082 5.60041 21.9589 6.44222 22.4103L13.0188 25.9308C13.808 26.3564 14.755 26.3564 15.5442 25.9308L22.1208 22.4103C22.9626 21.9589 23.4887 21.082 23.4887 20.1406V16.5169L15.5442 20.7725C14.755 21.1981 13.808 21.1981 13.0188 20.7725L5.07429 16.5169ZM13.0188 4.0595L1.93068 9.99158C1.02311 10.4816 1.02311 11.7712 1.93068 12.2612L13.0188 18.1933C13.808 18.6189 14.755 18.6189 15.5442 18.1933L26.1194 12.5321V20.1535C26.1194 20.8628 26.7113 21.4431 27.4347 21.4431C28.1581 21.4431 28.75 20.8628 28.75 20.1535V11.8873C28.75 11.4101 28.4869 10.9846 28.066 10.7524L15.5442 4.0595C15.1556 3.85629 14.7219 3.75 14.2815 3.75C13.8411 3.75 13.4074 3.85629 13.0188 4.0595Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrainement);
export default __webpack_public_path__ + "static/media/entrainement.c6aa41b02e2c3662baefef9eb83a44ad.svg";
export { ForwardRef as ReactComponent };